jQuery(document).ready(function ($) {
    
    // 商品説明セクションスライダー01
    var mySwiper = new Swiper('#product-description-slide01', {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next#btn-next01',
        prevEl: '.swiper-button-prev#btn-prev01',
      },
      pagination: {
        el: '.swiper-pagination#pagi01',
        clickable: true
      }
    });
    // 商品説明セクションスライダー02
    var mySwiper = new Swiper('#product-description-slide02', {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next#btn-next02',
        prevEl: '.swiper-button-prev#btn-prev02',
      },
      pagination: {
        el: '.swiper-pagination#pagi02',
        clickable: true
      }
    });
    // 商品説明セクションスライダー03
    var mySwiper = new Swiper('#product-description-slide03', {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next#btn-next03',
        prevEl: '.swiper-button-prev#btn-prev03',
      },
      pagination: {
        el: '.swiper-pagination#pagi03',
        clickable: true
      }
    });
    // 商品説明セクションスライダー04
    var mySwiper = new Swiper('#product-description-slide04', {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next#btn-next04',
        prevEl: '.swiper-button-prev#btn-prev04',
      },
      pagination: {
        el: '.swiper-pagination#pagi04',
        clickable: true
      }
    });
    // 商品説明セクションスライダー05
    var mySwiper = new Swiper('#product-description-slide05', {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next#btn-next05',
        prevEl: '.swiper-button-prev#btn-prev05',
      },
      pagination: {
        el: '.swiper-pagination#pagi05',
        clickable: true
      }
    });
    // 商品説明セクションスライダーギャラリー
    var mySwiper = new Swiper('#product-description-slide-gall', {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next#btn-next-gall',
        prevEl: '.swiper-button-prev#btn-prev-gall',
      },
      pagination: {
        el: '.swiper-pagination#pagi-gall',
        clickable: true
      }
    });
    // /* カスタムカテゴリー　ハーフサイズ */
    var mySwiper = new Swiper('.category_item_half .swiper-container', {
      loop: true,
      effect: 'fade',
      speed: 800,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        freeMode: false,
        followFinger: false

      }
    });
});

$(window).on('load', function(){
  // ページトップスクロール
  var $pagetop = $('.pagetop');
  $pagetop.on('click', function() {
    var speed = 700,
        href = $(this).attr("href"),
        target = $(href === "#" || href === "" ? 'html' : href),
        position = target.offset().top,
        winTop = $(window).scrollTop(),
        targetBody;

        $(window).scrollTop( winTop + 1 );
    if ( $('html').scrollTop() > 0 ) {
        targetBody = $('html');
    } else if ( $('body').scrollTop() > 0 ) {
        targetBody = $('body');
    }
    targetBody.animate({scrollTop: position}, speed, 'swing');
    return false; 
  });

  // 販売期間ルールがある場合、購入ボタンを表示しない
  // if($('.template-product').find('.ruffruff-selling-periods__product-message').length > 0){
  //     alert('販売期間ルールあり');
  //     $('.template-product').find('.custom-section_cart-btn').css({'display':'none'});
  // }else{
  //     alert('販売期間ルールなし');
  // }
});


